import bowser from 'bowser'

const browser = {
  saveAsCsvFile (text, filename) {
    if (bowser.msie && bowser.version < 10) {
      return
    }

    var BOM = '\uFEFF'
    var textFileAsBlob = new Blob([BOM, text], {
      type: 'text/csv;charset=utf-8'
    })

    if (bowser.msie && !!window.navigator.msSaveBlob) {
      window.navigator.msSaveBlob(textFileAsBlob, filename)
    } else {
      var downloadLink = document.createElement('a')
      downloadLink.download = filename
      downloadLink.href = window.URL.createObjectURL(textFileAsBlob)
      downloadLink.onclick = function (e) { document.body.removeChild(e.target) }
      downloadLink.style.display = 'none'
      document.body.appendChild(downloadLink)
      downloadLink.click()
    }
  }
}

export default browser
